<template>
  <header class="sticky top-0 z-10 border-b border-gray-100 bg-white">
    <div class="px-3 pt-3">
      <form
        class="flex h-9 items-center rounded-lg border border-gray-200 bg-gray-50 px-2.5"
        role="search"
        @submit.prevent
      >
        <SearchIcon class="h-4 w-4 flex-none text-gray-400" />
        <input
          id="search"
          v-model="search"
          type="search"
          aria-label="輸入搜尋關鍵字"
          class="h-full min-w-0 flex-grow border-0 bg-transparent px-2 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-0"
          placeholder="搜尋商品"
          @input="searchContent"
        />
        <button
          v-if="search"
          type="button"
          aria-label="清除搜尋內容"
          class="flex h-7 w-7 flex-none items-center justify-center rounded-full text-gray-400 active:bg-gray-100"
          @click="deleteSearch"
        >
          <XIcon class="h-4 w-4" />
        </button>
      </form>
    </div>

    <div class="flex items-end justify-between gap-3 px-3 py-3">
      <div class="min-w-0">
        <h1 class="truncate text-[15px] font-bold leading-tight text-gray-900">{{ title }}</h1>
        <p class="mt-0.5 text-[11px] text-gray-400">{{ total }} 件商品</p>
      </div>
      <button
        v-if="search"
        type="button"
        class="flex-none text-[11px] font-medium text-primary active:opacity-70"
        @click="deleteSearch"
      >
        清除
      </button>
    </div>
  </header>
</template>

<script>
import { debounce } from "lodash";
import { SearchIcon, XIcon } from "@vue-hero-icons/outline";

export default {
  components: {
    SearchIcon,
    XIcon,
  },
  props: {
    title: {
      type: String,
      default: "全部商品",
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      search: this.$route.query.keywords || "",
    };
  },
  methods: {
    searchContent: debounce(function () {
      const searchTerm = this.search && this.search.trim();
      if (this.$track && searchTerm && searchTerm.length >= 2) {
        this.$track.event("search", {
          search_term: searchTerm,
          results_count: this.total,
        });
      }
      this.$emit("getSearchContent", this.search);
    }, 500),
    deleteSearch() {
      this.search = "";
      this.$emit("getSearchContent", this.search);
    },
  },
  watch: {
    "$route.query.keywords"(value) {
      this.search = value || "";
    },
  },
};
</script>

<style lang="scss" scoped></style>
